import Chart, { useChart } from '@aibees/shared/components/chart';
import { useTheme } from '@mui/material';
import { memo } from 'react';

export const ReportGroupChart = memo(() => {
  const { palette } = useTheme();

  const chartOptions = useChart([], {
    labels: ['Mobile', 'Direct Dial', 'Home Phone', 'Not Found'],
    colors: [
      palette.success.main,
      palette.primary[500],
      palette.warning[500],
      palette.error[500],
    ],
    stroke: {
      show: false,
    },
    legend: {
      horizontalAlign: 'center',
      floating: false,
      /* containerMargin: {
        top: 0,
      }, */
      position: 'right',
      height: 100,
      fontSize: '12px',
    },
    tooltip: {
      fillSeriesColor: false,
    },
    plotOptions: {
      pie: {
        donut: {
          size: '90%',
        },
      },
    },
  });

  return (
    <Chart
      dir="ltr"
      type="donut"
      series={[44, 22, 8]}
      options={chartOptions}
      width={330}
    />
  );
});

ReportGroupChart.displayName = 'ReportGroupChart';
